import { render, staticRenderFns } from "./companyLicenseUploadApply.vue?vue&type=template&id=5164e6a8&scoped=true&"
import script from "./companyLicenseUploadApply.vue?vue&type=script&lang=js&"
export * from "./companyLicenseUploadApply.vue?vue&type=script&lang=js&"
import style0 from "./companyLicenseUploadApply.vue?vue&type=style&index=0&id=5164e6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5164e6a8",
  null
  
)

export default component.exports